export default {
    data () {
        return {
            filter_show: false
        }
    },
    methods: {
        toggleFilter (filter_show) {
            this.filter_show = filter_show !== undefined ? filter_show : !this.filter_show
        }
    }
}
